export default class AskTheCommunity {
    constructor() {
        this.settings = {
            forum: document.querySelector('[data-block="questions-forum"]'),
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if (this.settings.forum) {
            const searchText = document.querySelector('.ap-search-btn');
            searchText.textContent = '';

            const searchPlaceholder = document.querySelector('.ap-search-input.ap-form-input');
            searchPlaceholder.placeholder = 'What would you like to know about?';
        }
    }
}

new AskTheCommunity();
